<template>
  <v-dialog
    v-model="isOpen"
    max-width="1000"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    scrollable
  >
    <v-card flat>
      <v-card-title>
        <v-toolbar flat>
          <v-toolbar-title>
            Create Case File
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn elevation="0" @click="close">
            Close
            <v-icon class="ml-1">
              mdi-close
            </v-icon>
          </v-btn>
        </v-toolbar>
        <v-tabs v-model.number="tab">
          <v-tab >Personal Information</v-tab>
          <v-tab >Account Information</v-tab>
          <v-tab >Employment Details</v-tab>
          <v-tab >Loan Details</v-tab>
        </v-tabs>
      </v-card-title>

      <v-card-text style="height: 800px;">

        <v-tabs-items v-model.number="tab">
          <v-tab-item>
            <PersonalTab ref="pForm" @submit="form.personalDetails = $event"/>
          </v-tab-item>
          <v-tab-item>
            <AccountTab ref="aForm" @submit="form.accountDetails = $event"/>
          </v-tab-item>
          <v-tab-item>
            <EmploymentTab ref="eForm" @submit="form.employmentDetails = $event"/>
          </v-tab-item>
          <v-tab-item>
            <LoanTab ref="lForm" @submit="form.loanDetails = $event"/>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-card-actions >
        <v-spacer></v-spacer>
        <v-btn text @click="cancel">
          Cancel
        </v-btn>
        <v-btn color="primary" @click="tab !== 0 ? tab-- : tab">
          Back
        </v-btn>
        <v-btn v-if="tab !== 3" color="primary" @click="tab++">
          Next
        </v-btn>
        <v-btn v-else color="green" dark @click="submit">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import PersonalTab from './PersonalTab.vue'
import AccountTab from './AccountTab.vue'
import EmploymentTab from './EmploymentTab.vue'
import LoanTab from './LoanTab.vue'
 import PageMixin from '@/mixins/page.mixin';
import { ManualLoanInsertionService } from '../../services/manual-loan-insertion.service'

const service = new ManualLoanInsertionService()

export default {
  mixins: [PageMixin],

  components: { PersonalTab, AccountTab, EmploymentTab, LoanTab },

  data() {
    return {
      isOpen: false,
      tab: 'personal',
      form: {},
      formRefs: {
        pForm: '0',
        aForm: '1',
        eForm: '2',
        lForm: '3',
      }
    }
  },

  methods: {
    open() {
      this.isOpen = true;
    },

    close() {
      Object.keys(this.formRefs).forEach(ref => {
        if(this.$refs[ref])
        this.$refs[ref].clear();
      });
      this.isOpen =false
    },

    cancel() {
      Object.keys(this.formRefs).forEach(ref => {
        if(this.$refs[ref])
        this.$refs[ref].clear();
      });
      this.isOpen =false
    },

    async submit() {
      let isAllValid = true;
      const refs = Object.entries(this.formRefs);
      
      for (let i = 0; i < refs.length; i++) {
        const [ref, value] = refs[i];
        
        if(!this.$refs[ref]) { 
          this.tab = Number(value);
          isAllValid = false;
          break;
        }

        const isValid = await this.$refs[ref].validate();
        
        if(!isValid) {
          this.tab = Number(value);
          isAllValid = false; 
          break;
        } 

        this.$refs[ref].submit();
      }
      
      if(!isAllValid) {
        this.showSnack({
          color: 'error',
          title: 'Form Incomplete.'
        })
      }

      try {
        let data = {};
        Object.keys(this.form).forEach(key => {
          data = { ...data, ...this.form[key] }
        })
        await service.createCaseFile(data);
        this.showSnack({
          color: 'success',
          title: 'Submited Successfully.',
          message: 'Case file was submited Successfully.'
        })
        this.close();
      } catch (error) {
        console.log(this);
        
        this.httpErrorHandler(error, {
          title: 'Something went wrong.',
          message: 'An error occurred while saving case file.'
        });
      }
    }
  }
}
</script>